import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import LoaderGif from '../../../icons/LoaderGif.gif';
import { Modal } from 'react-bootstrap';
import CheckBox from '../../CheckBox';
import FormInput from '../../FormInput';
import { TextField } from '@material-ui/core';
import { usersAdding, usersAddError } from '../../../screens/Admin/selectors';
import { addUserRequested } from '../../../screens/Admin/actions';

function AddUser({
    open,
    onCancel,
    totalAdminsCount,
    currentAdminsCount,
    totalCitizenScientistCount,
    currentCitizenScientistCount,
    emails,
}) {
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [admin, setAdmin] = useState(false);
    const [customError, setCustomError] = useState(null);
    const [researcher, setResearcher] = useState(false);
    const loading = useSelector((state) => usersAdding(state));
    const error = useSelector((state) => usersAddError(state));
    const [showError, setShowError] = useState(false);

    const onSave = () => {
        if (emails.indexOf(email.toLowerCase()) === -1) {
            const roles = [];
            admin && roles.push('PARTNER');
            researcher && roles.push('EXPERT_INDIVIDUAL');
            dispatch(addUserRequested(email, roles));
            setShowError(true);
        } else {
            setCustomError(
                'User has already been invited, if you want to assign a new role to this user, you can do it from Change user type. ',
            );
            setShowError(true);
        }
    };

    useEffect(() => {
        !loading && !error && onCancel();
    }, [loading]);

    useEffect(() => {
        if (open) {
            setEmail('');
            setAdmin(false);
            setResearcher(false);
        }
        setShowError(false);
    }, [open]);

    return (
        <div className="admin-delete-modal">
            <Modal
                show={open}
                onHide={onCancel}
                dialogClassName={'admin-delete-modal'}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                centered={true}
                animation={true}
            >
                <div className="row">
                    <div className="col-12">
                        <div className="row title">Invite User</div>
                        <>
                            <div className="row justify-content-center">
                                <FormInput
                                    title={''}
                                    bootstrapIcon="icon-latest-add"
                                    bottomtext="Email address must be a valid email. Participation requires acceptance of an emailed invitation."
                                >
                                    <TextField
                                        value={email}
                                        type={'email'}
                                        placeholder={'Email Address'}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                            setCustomError(null);
                                        }}
                                    />
                                </FormInput>
                            </div>
                            <div className="row justify-content-center">
                                Please select the role(s)
                            </div>

                            <div
                                className="row justify-content-around"
                                style={{ padding: '15px 0px' }}
                            >
                                <CheckBox
                                    label={'Admin'}
                                    id={`user-checkbox-admin`}
                                    onClick={(e) => setAdmin(e.target.checked)}
                                    isBold={true}
                                    selected={admin}
                                    disabled={
                                        totalAdminsCount === currentAdminsCount
                                    }
                                />
                                <CheckBox
                                    label={'Researcher'}
                                    id={`user-checkbox-researcher`}
                                    onClick={(e) =>
                                        setResearcher(e.target.checked)
                                    }
                                    isBold={true}
                                    selected={researcher}
                                    disabled={
                                        totalCitizenScientistCount ===
                                        currentCitizenScientistCount
                                    }
                                />
                            </div>
                        </>
                        <div className="row">
                            {showError ? customError || error : ''}
                        </div>
                        <div className="row">
                            <button
                                className={'btn btn-block delete-admin-button'}
                                type={'button'}
                                disabled={
                                    !(
                                        /\S+@\S+\.\S+/.test(email) &&
                                        (admin || researcher)
                                    ) || customError
                                }
                                onClick={() => onSave()}
                            >
                                {loading ? (
                                    <img
                                        src={LoaderGif}
                                        width={'25px'}
                                        height={'25px'}
                                    />
                                ) : (
                                    'Send Invitation'
                                )}
                            </button>
                        </div>

                        <div className="row mt-1">
                            <button
                                className={'btn btn-block delete-button-cancel'}
                                type={'button'}
                                onClick={onCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

AddUser.propTypes = {
    open: PropTypes.bool,
    user: PropTypes.object,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    canRemoveOwner: PropTypes.bool,
    totalAdminsCount: PropTypes.number,
    currentAdminsCount: PropTypes.number,
    totalCitizenScientistCount: PropTypes.number,
    currentCitizenScientistCount: PropTypes.number,
    emails: PropTypes.arrayOf(PropTypes.string),
};

AddUser.defaultProps = {
    open: false,
    canRemoveOwner: false,
    user: {},
    emails: null,
    onCancel: () => {},
    onConfirm: () => {},
    totalAdminsCount: 0,
    currentAdminsCount: 0,
    totalCitizenScientistCount: 0,
    currentCitizenScientistCount: 0,
};

export default AddUser;
